import {Injectable} from '@angular/core';
import {AbstractControl, NonNullableFormBuilder, Validators} from "@angular/forms";
import {ServiceForm, ServiceFormValues} from "../model/service-form";
import {autocompleteModelValidator} from "../../../infrastructure/helper/autocomplete-model-validator";
import {HttpClient, HttpErrorResponse} from "@angular/common/http";
import {catchError} from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class ServiceFormService {
  public get form(): ServiceForm {
    return this.formBuilder.group<ServiceFormValues>({
      adxInvoiceId: [],
      vendor: [null, [Validators.required, autocompleteModelValidator()]],
      departDate: ['', Validators.required],
      returnDate: ['', Validators.required],
      travelTypeId: [null, Validators.required],
      externalTravelServiceTypeId: [
        null,
        (control: AbstractControl) => {
          const parent = control.parent;
          if (parent && parent.get('travelTypeId')?.enabled) {
            return Validators.required(control);
          }
          return null;
        }
      ],
      recordLocator: [],
      numberOfPax: [
        null,
        [
          Validators.required,
          Validators.min(0),
          Validators.max(150),
        ]
      ],
      numberOfRooms: [
        null,
        [
          Validators.required,
          Validators.min(0),
          Validators.max(150),
        ]
      ],
      startingTicketNo: [],
      interCode: ['-1', Validators.required],
      submitToCode: ['', Validators.required],
      confirmationNumber: [],
      commAmt: [null, Validators.required],
      commRate: [null, [Validators.required, Validators.pattern(/^-?(\d+([.]\d*)?|[.]\d+)$/)]],
      totalFare: [null, Validators.required],
      currency: [null, Validators.required],
      dataSourceId: [],
      agent: [null, [Validators.required, autocompleteModelValidator()]],
    });
  }

  constructor(
    private readonly formBuilder: NonNullableFormBuilder,
    private readonly httpClient: HttpClient,
  ) {
  }

  public create(body: Record<string, unknown>) {
    return this.httpClient.post('dbov2/adx-booking/create-from-form', JSON.stringify(body))
      .pipe(
        catchError((error: HttpErrorResponse) => {
          throw new Error(error?.message || 'Server error');
        })
      );
  }
}
